export const DELIVERY_OPTIONS = [
  {
    name: 'Самовывоз',
    descr: 'Самостоятельное получение продукции с НПЗ или НБ',
    value: 'autoSelf',
    valueForSeller: 'customerTruck',
    alternativeValue: 'self',
    dateText: 'Дата отгрузки',
  },
  {
    name: 'Автодоставка',
    descr: 'Доставка автотранспортом продукции в указанное место',
    value: 'autoDelivery',
    valueForSeller: 'sellerTruck',
    alternativeValue: 'auto',
    dateText: 'Дата доставки',
  },
];

export const AUTO_SELF = [
  {
    name: 'Самовывоз',
    descr: 'Самостоятельное получение продукции с НПЗ или НБ',
    value: 'autoSelf',
    valueForSeller: 'customerTruck',
    alternativeValue: 'self',
    dateText: 'Дата отгрузки',
  },
];

export const enum shippingOptions {
  autoSelf = 'Самовывоз',
  customerTruck = 'Самовывоз',
  autoDelivery = 'Автодоставка',
  sellerTruck = 'Автодоставка',
  customerRailway = 'ЖД-самовывоз',
  sellerRailway = 'ЖД-доставка',
}

export const enum safeOptions {
  safeOffers = 'Безопасная сделка',
  allOffers = 'Все сделки',
}

export const CUSTOMER_TRUCK = ['autoSelf', 'customerTruck', 'self']; // Самовывоз
export const SELLER_TRACK = ['autoDelivery', 'sellerTruck', 'auto']; // Автодоставка
